export {default} from './TextLink.js';



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Backoffice/TextLink/index.js